import { ButtonHTMLAttributes } from "react";

import { cva, VariantProps } from "class-variance-authority";
import { cn } from "../../../utils/cn";
import { UnstyledButton } from "../UnstyledButton";

const styles = cva(
  [
    "hover:bg-gray-100 active:bg-gray-200",
    "disabled:cursor-not-allowed disabled:pointer-events-none disabled:opacity-50",
  ],
  {
    variants: {
      styleVariant: {
        filled: "bg-gray-200",
      },
      vRounded: {
        true: "rounded-full",
        false: "rounded-none",
      },
    },
  },
);
type IconButtonVariantProps = VariantProps<typeof styles>;

export interface IconButtonProps
  extends IconButtonVariantProps,
    ButtonHTMLAttributes<HTMLButtonElement> {
  styleVariant?: "filled";
  "data-testid"?: string;
}

export function IconButton({
  className,
  styleVariant,
  vRounded,
  "data-testid": dataTestId,
  ...rest
}: IconButtonProps) {
  const testId = dataTestId || "icon-button";

  return (
    <UnstyledButton
      className={cn(styles({ styleVariant, vRounded }), className)}
      data-testid={testId}
      {...rest}
    />
  );
}
